module.exports = __webpack_public_path__ + "img/login-logo.9936d234.png";